import { Image } from '@ccg/core';
import React$1 from 'react';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import SpecialHeadline$1 from '../SpecialHeadline/SpecialHeadline.js';
import StyledTeamList from './TeamList.style.js';

const TeamList = ({
  headline,
  copy,
  members,
  direction,
  link
}) => {
  const filteredMembers = members.filter((item, i) => i < 12);
  return /*#__PURE__*/React$1.createElement(StyledTeamList, {
    isRightAligned: direction === 'right'
  }, (headline || copy) && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, headline && /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
    as: "h2",
    variant: "headline",
    text: headline,
    className: "teamList__headline"
  }), copy && /*#__PURE__*/React$1.createElement(Typography$1, {
    variant: "copyIntro",
    className: "teamList__copy"
  }, copy)), /*#__PURE__*/React$1.createElement("div", {
    className: "teamList__swipe-indicator"
  }, /*#__PURE__*/React$1.createElement("svg", {
    width: "32",
    height: "38",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 38"
  }, /*#__PURE__*/React$1.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M22.754 34.869h-5.333a7.323 7.323 0 01-6.569-4.033L4.153 15.943c-.13-.326 0-.716.325-.846l.52-.26a4.327 4.327 0 013.253-.325 4.269 4.269 0 012.536 2.08l.13.261V6.122C10.917 4.43 12.348 3 14.04 3c1.691 0 3.122 1.43 3.122 3.122v7.089c.455-.26.975-.455 1.496-.455 1.3 0 2.341.845 2.731 2.016a2.846 2.846 0 011.626-.52 2.79 2.79 0 012.667 2.016 2.846 2.846 0 011.626-.52 2.776 2.776 0 012.796 2.796v8.91c0 4.098-3.316 7.415-7.349 7.415zM5.584 15.943l6.439 14.308c1.04 2.016 3.122 3.317 5.398 3.317h5.333c3.317 0 6.049-2.732 6.049-6.049v-8.91c0-.845-.65-1.496-1.496-1.496s-1.496.65-1.496 1.496v2.472c0 .39-.26.65-.65.65s-.65-.26-.65-.65v-3.968c0-.845-.651-1.496-1.497-1.496-.845 0-1.496.65-1.496 1.496v3.968c0 .39-.26.65-.65.65s-.65-.26-.65-.65v-5.464c0-.845-.65-1.496-1.496-1.496s-1.496.65-1.496 1.496v5.464c0 .39-.26.65-.65.65s-.65-.26-.65-.65V6.12c0-.975-.846-1.82-1.822-1.82-.975 0-1.821.845-1.821 1.82v13.334c0 .325-.195.585-.52.65a.654.654 0 01-.716-.325l-1.365-2.602c-.39-.715-.976-1.235-1.757-1.43-.845-.26-1.625-.13-2.34.195z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "M18.586 3h8.276v1.552h-8.276zM1 6.103h8.276v1.552H1zM18.586 6.103h4.138v1.552h-4.138zM5.138 3h4.138v1.552H5.138z"
  })))), /*#__PURE__*/React$1.createElement("div", {
    className: "teamList__circle"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "teamList__members"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "teamList__members-inner"
  }, filteredMembers.map(({
    id,
    image,
    name,
    title
  }) => /*#__PURE__*/React$1.createElement("div", {
    key: id,
    className: "teamList__member-container"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: `teamList__member animate-${Math.floor(Math.random() * 4)}`
  }, /*#__PURE__*/React$1.createElement(Image, {
    src: image.url,
    srcset: image.srcset,
    alt: image.alt,
    lazy: true
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "teamList__member-background"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "teamList__member-info"
  }, /*#__PURE__*/React$1.createElement(Typography$1, {
    variant: "subline",
    className: "teamList__member-name"
  }, name), /*#__PURE__*/React$1.createElement(Typography$1, {
    variant: "small",
    className: "teamList__member-title"
  }, title))))))), link && /*#__PURE__*/React$1.createElement("div", {
    className: "teamList__link"
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({}, link, {
    icon: "rightArrow"
  }), link.label)));
};

TeamList.propTypes = {
  headline: PropTypes$1.string,
  copy: PropTypes$1.string,
  members: PropTypes$1.arrayOf(PropTypes$1.shape()).isRequired,
  direction: PropTypes$1.oneOf(['left', 'right']),
  link: PropTypes$1.shape()
};
TeamList.defaultProps = {
  headline: null,
  copy: null,
  direction: 'left',
  link: null
};

export default TeamList;
